<template>
  <div class="card shadow-sm">
    <div class="card-header">
      <h3 class="card-title">
        <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
          <li class="nav-item" @click="toggleSubTab('tab-questions')">
            <a class="nav-link text-active-primary ms-0 me-10" :class="{'active' : route.query.tab === 'tab-questions' }"  data-bs-toggle="tab" href="#tab-questions">
              {{$t("events.forms.title")}}
            </a>
          </li>
          <li class="nav-item" @click="toggleSubTab('tab-subscriptions')" v-if="$can(abilities.CAN_VIEW_EVENT_SUBSCRIPTOR) || $can(abilities.CAN_VIEW_EVENT_ALL_SUBSCRIPTOR)">
            <a class="nav-link text-active-primary ms-0 me-10" :class="{'active' : route.query.tab === 'tab-subscriptions' }"  data-bs-toggle="tab" href="#tab-subscriptions">
              {{ $t('events.inscriptionsList') }}
            </a>
          </li>
          <li class="nav-item" @click="toggleSubTab('tab-invitations')">
            <a class="nav-link text-active-primary ms-0 me-10" :class="{'active' : route.query.tab === 'tab-invitations' }"  data-bs-toggle="tab" href="#tab-invitations">
              {{$t("events.invitations")}}
            </a>
          </li>
        </ul>
      </h3>
    </div>
    <div class="card-body">
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show " :class="{'active' : route.query.tab === 'tab-questions' }" id="tab-questions" role="tabpanel">
          <Loader :isLoading="loading">
            <QuestionIndex/> 
          </Loader>
        </div>
        <div class="tab-pane fade show " :class="{'active' : route.query.tab === 'tab-subscriptions' }" v-if="$can(abilities.CAN_VIEW_EVENT_SUBSCRIPTOR) || $can(abilities.CAN_VIEW_EVENT_ALL_SUBSCRIPTOR)" id="tab-subscriptions" role="tabpanel">
          <Loader :isLoading="loading"> 
            <InscriptionTab/>
          </Loader>
        </div>
        <div class="tab-pane fade show " :class="{'active' : route.query.tab === 'tab-invitations' }" id="tab-v" role="tabpanel">
          <Loader :isLoading="loading">
            <InvitationTab/> 
          </Loader>
        </div>
      </div>
    </div>
  </div>

 
</template>

<script setup>
import { onMounted, ref, watch} from "vue";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import abilities from "@/composables/abilities";
import QuestionIndex from "../../questions/Index.vue";
import InvitationTab from "./InvitationTab"
import Loader from "../../../../../components/Loader.vue"
import InscriptionTab from "./InscriptionTab.vue";

const store = useStore()
const route = useRoute()
const router = useRouter()

const emits = defineEmits(['reload'])
const loading = ref(false)

watch(() => route.query.tab, (value) => {
    if(value){
        loadData()
    }
})

function loadData() {
  if(route.query.tab === 'tab-subscriptions'){
    Promise.all([
      store.dispatch('events/loadEventInscriptionStatus'),
        ])
  }
}

onMounted( () => {
  loadData()
})

function toggleSubTab(tab){
  router.replace({ query: { ...route.query, tab } });
  loading.value = true
  setTimeout(() => {
    loading.value = false
  }, "2000");
}

</script>

<style scoped>
  .card-header {
    padding-bottom: 0;
  }

  .nav.nav-line-tabs {
    align-items: flex-end;
    height: 100%;
  }

  .nav-line-tabs.nav-line-tabs-2x .nav-item {
    margin-bottom: -8px;
  }

  .nav-line-tabs .nav-item {
    height: 100%;
    display: flex;
    align-items: flex-end;
  }

  .nav-line-tabs .nav-link {
    border-bottom: 2px solid transparent;
    padding-bottom: 15px; 
  }

</style>